
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/squad",
      function () {
        return require("private-next-pages/team/squad.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/squad"])
      });
    }
  